import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from "@mui/material";
// hooks
import useResponsive from '../../hooks/useResponsive';


export default function WhyTodoDialog({ isOpen, closeDialog}) {
  const smUp = useResponsive('up', 'sm');

  return (
    <Dialog open={isOpen} onClose={closeDialog} fullWidth maxWidth="xs">
      <DialogContent sx={{ my: { xs: 0, sm: 1 }}}>
        <Typography variant="h5" sx={{ mb: { xs : 3, sm : 4 } }}>
          데일리 투두, 무엇인가요?
        </Typography>
        <Typography variant="h6" gutterBottom>
          ✅ 크루가 할 일을 쓰고, 완료하면 체크해요
        </Typography>
        <Typography paragraph sx={{ color: 'text.secondary' }} variant={smUp ? "body1" : "body2"}>
          크루가 앞으로 어떤 일을 할지, 지금까지 어떤 일을 했는지 실시간으로 확인할 수 있어요.
        </Typography>
        <Typography variant="h6" gutterBottom>
          ⏰ 크루의 작업 시간도 알 수 있어요
        </Typography>
        <Typography sx={{ color: 'text.secondary' }} variant={smUp ? "body1" : "body2"}>
          작업마다 실제로 걸린 시간을 알 수 있어요.<br />
          작업 시간에 소통 시간은 포함되어 있지 않아요.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button
          sx={{ px: 4 }}
          fullWidth={smUp ? false : true}
          onClick={closeDialog}
          variant="contained"
          size="large"
        >
          확인했어요
        </Button>
      </DialogActions>
    </Dialog>
  )
}